
import React from 'react';
import { motion } from 'framer-motion';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { ArrowRight, Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import Gradient from '@/assets/medihub_gradient_mesh.jpg';

const IndustryCTA = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="rounded-xl overflow-hidden relative">
          <div className="absolute inset-0 z-0">
            <img
              src={Gradient}
              alt="EventHub háttér"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/50 z-0"></div>
          </div>
          
          <div className="relative z-10 p-8 md:p-12 text-white">
            <div className="max-w-3xl mx-auto text-center">
              <Badge className="bg-white/20 text-white hover:bg-white/30 mb-4">Egyedi megoldás az Ön iparágára</Badge>
              
              <h2 className="text-3xl md:text-4xl font-bold mb-6">
                Készüljön fel a következő szintre eseményeivel!
              </h2>
              
              <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
                Tegye hatékonyabbá eseményei szervezését, növelje résztvevői számát és 
                egyszerűsítse az adminisztrációt egy minden igényt kielégítő professzionális rendszerrel!
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl mx-auto mb-8">
                <div className="flex items-start gap-2">
                  <Check className="h-5 w-5 text-medihub-accent mt-0.5 flex-shrink-0" />
                  <span className="text-white/90">Testreszabható az iparági igények szerint</span>
                </div>
                <div className="flex items-start gap-2">
                  <Check className="h-5 w-5 text-medihub-accent mt-0.5 flex-shrink-0" />
                  <span className="text-white/90">Minden szakmai területhez adaptálható</span>
                </div>
                <div className="flex items-start gap-2">
                  <Check className="h-5 w-5 text-medihub-accent mt-0.5 flex-shrink-0" />
                  <span className="text-white/90">Könnyen integrálható meglévő rendszerekkel</span>
                </div>
                <div className="flex items-start gap-2">
                  <Check className="h-5 w-5 text-medihub-accent mt-0.5 flex-shrink-0" />
                  <span className="text-white/90">Folyamatos támogatás és fejlesztés</span>
                </div>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/contact">
                  <Button size="lg" className="bg-medihub-accent text-white hover:bg-medihub-accent/90 w-full sm:w-auto">
                    Kérjen egyedi ajánlatot
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </Link>
                
                <Link to="/industries">
                  <Button variant="outline" size="lg" className="bg-transparent border-white text-white hover:bg-white/10 w-full sm:w-auto">
                    További iparági megoldások
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustryCTA;
